import json from './json';
import url from './url';
import util from './util';
import config from '../../../configs/config';

export default {
	get(classMethod, ...args) {
		return this.request({ classMethod, args });
	},
	post(classMethod, ...args) {
		return this.request({post: true, classMethod, args });
	},
	async request(opts) {
		let endpointBase = config.endpointBase || '';
		let httpOpts = {};
		if (config.withCredentials) {
			httpOpts.withCredentials = true;
		}

		let response;
		if (opts.post) {
			let data = { args: opts.args };
			response = await axios.post(endpointBase + '/api/call/' + opts.classMethod, data, httpOpts);
		} else {
			let argsJson = json.encode(opts.args);
			httpOpts.params = { argsJson };
			response = await axios.get(endpointBase + '/api/call/' + opts.classMethod, httpOpts);
		}
		let res = response.data.res;
		let chTime = response.headers && response.headers['x-ch-time'];
		if (chTime) {
			//console.log(chTime.split(', ').map(n => parseFloat(n)));
		}
		if (response.data.err) {
			throw new Error(response.data.err);
		}
		return res;
	},
	async download(classMethod, ...args) {
		let cookieName = 'd_' + util.getRandomString(10);
		let expires = moment().add(10, 'minute').toString();

		document.cookie = `${cookieName}=1; path=/; expires=${expires}`;

		let argsJson = JSON.stringify(args);
		let url = '/api/call/' + classMethod + '?argsJson=' + url.encode(argsJson) + '&downloadCookie=' + cookieName;
		let frame = document.getElementById('download-frame');
		frame.src = url;

		let isDownloading;
		do {
			isDownloading = document.cookie.indexOf(cookieName + '=1') !== -1;
			await util.sleep(500);
		} while (isDownloading);
	}
}